/**
 * @generated SignedSource<<03bdf8f361c8eb201c9dfdf04f8a02bd>>
 * @relayHash 03c88593e0a708b4a806a4bb00935330
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 2a40daa03e54d1598b3952a7a86fc5c6a154a8756d1cb79b58cc7bf3f2e125ee

import type { ConcreteRequest, Query } from 'relay-runtime';
export type TopNavigationQuery$variables = Record<PropertyKey, never>;
export type TopNavigationQuery$data = {
  readonly siteConfiguration: {
    readonly customSiteLogo: boolean;
  } | null | undefined;
  readonly siteDescription: {
    readonly logoUrl: string | null | undefined;
  } | null | undefined;
  readonly siteSettings: {
    readonly showApplicationTitle: boolean;
    readonly siteTitle: string;
  } | null | undefined;
  readonly user: {
    readonly displayName: string | null | undefined;
    readonly emails: ReadonlyArray<{
      readonly isPrimary: boolean | null | undefined;
      readonly value: string | null | undefined;
    } | null | undefined> | null | undefined;
    readonly id: string | null | undefined;
    readonly photos: ReadonlyArray<{
      readonly value: string | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type TopNavigationQuery = {
  response: TopNavigationQuery$data;
  variables: TopNavigationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "value"
},
v1 = [
  {
    "concreteType": "SiteConfiguration",
    "kind": "LinkedField",
    "name": "siteConfiguration",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "customSiteLogo"
      }
    ]
  },
  {
    "concreteType": "SiteSettings",
    "kind": "LinkedField",
    "name": "siteSettings",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "siteTitle"
      },
      {
        "kind": "ScalarField",
        "name": "showApplicationTitle"
      }
    ]
  },
  {
    "concreteType": "SiteDescription",
    "kind": "LinkedField",
    "name": "siteDescription",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "logoUrl"
      }
    ]
  },
  {
    "alias": "user",
    "args": [
      {
        "kind": "Literal",
        "name": "current",
        "value": true
      }
    ],
    "concreteType": "AtlassianUser",
    "kind": "LinkedField",
    "name": "confluence_atlassianUser",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "kind": "ScalarField",
        "name": "displayName"
      },
      {
        "concreteType": "AtlassianUserEmail",
        "kind": "LinkedField",
        "name": "emails",
        "plural": true,
        "selections": [
          (v0/*: any*/),
          {
            "kind": "ScalarField",
            "name": "isPrimary"
          }
        ]
      },
      {
        "concreteType": "AtlassianUserPhoto",
        "kind": "LinkedField",
        "name": "photos",
        "plural": true,
        "selections": [
          (v0/*: any*/)
        ]
      }
    ],
    "storageKey": "confluence_atlassianUser(current:true)"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "TopNavigationQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "TopNavigationQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "03c88593e0a708b4a806a4bb00935330",
    "id": "2a40daa03e54d1598b3952a7a86fc5c6a154a8756d1cb79b58cc7bf3f2e125ee",
    "metadata": {},
    "name": "TopNavigationQuery",
    "operationKind": "query",
    "text": "query TopNavigationQuery{siteConfiguration{customSiteLogo},siteSettings{siteTitle,showApplicationTitle},siteDescription{logoUrl},user:confluence_atlassianUser(current:true){id,displayName,emails{value,isPrimary},photos{value}}}"
  }
};
})();

(node as any).hash = "58252cd5493d65d590f00c523b3d3ad8";

export default node;
